import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeManagementReportRowCreate,
  detail: routeManagementReportRowDetail,
  home: routeManagementReportRowsHome,
  root: routeManagementReportRowsRoot,
} = createDoctypeRoutes({
  createName: 'new-management-report-row',
  createPath: 'new-management-report-row',
  detailName: 'managementReportRowDetail',
  doctype: DOCTYPES.TW_MANAGEMENT_REPORT_ROW,
  homeName: 'management-report-rows',
  path: 'management-report-rows',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/accounting/reportMapping/AddManagementReportRow.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/accounting/reportMapping/ViewManagementReportRow.vue'
      ),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routeManagementReportRowCreate,
  routeManagementReportRowDetail,
  routeManagementReportRowsHome,
  routeManagementReportRowsRoot,
}
